module.exports = __webpack_public_path__ + "static/media/blog_winter.22b14a8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog_winter.jpg
// module id = 874
// module chunks = 0